<!--
 モーダルダイアログのフレーム。中身はslotで与える。
-->
<template>
  <div class="modal-dialog" v-if="visible" @click.self="emitCloseEvent">
    <div class="modal-dialog-area">
      <button
        class="modal-dialog-close01"
        type="button"
        @click="emitCloseEvent"
      >
        <i class="material-icons">close</i>
      </button>
      <div class="modal-dialog-area-wrapper">
        <div class="modal-dialog-area-inr">
          <slot></slot>

          <button
            class="modal-dialog-close02"
            type="button"
            @click="emitCloseEvent"
            v-if="visibleFooter"
          >
            閉じる
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    visibleFooter: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    emitCloseEvent() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~green/_variables.scss';

.modal {
  &-dialog {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    border: none;
    top: 0;
    left: 0;
    z-index: 101;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &-area {
      padding: 16px;
      width: 95%;
      min-width: 288px;
      max-width: 480px;
      height: auto;
      min-height: 288px;
      max-height: 95%;
      background: #fff;
      border-radius: 12px;
      overflow-y: scroll;
      cursor: auto;
      @media (min-width: $width-wide) {
        padding: 16px 24px;
      }

      &-wrapper {
        margin-top: -24px;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      &-inr {
        // 横サイズで必須 + IE対策
        margin: auto;
        width: 100%;
        height: initial;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        @media (min-width: $width-wide) {
          margin: 0 16px;
        }
      }
    }
    &-close01 {
      position: relative;
      z-index: 102;
      margin-left: calc(100% - 4%);
      font-size: 0.75rem;
      color: $base-font-color;
      text-decoration: underline;
    }
    &-close02 {
      position: relative;
      z-index: 102;
      display: block;
      margin: 0 auto 8px;
      font-size: 0.75rem;
      text-align: center;
      color: $base-font-color;
      text-decoration: underline;
    }
  }
}
</style>
